module.exports = __webpack_public_path__ + "static/media/fortnite.08344dc0.jpg";